import { AssigneeEntity } from '@omnea-app/core/blocks'
import { CurrencyCode } from 'utils/currency/getCurrencyCodes'
import { DateFormatKey } from '../date/dateFormat'
import { UserSyncConfig, defaultUserSyncConfig } from './userSyncConfigSchema'

export type OrganisationSettings = {
  budgetApprovalThresholdColumnsVisibility: {
    inBudget: boolean
    departments: boolean
  }
  defaultCurrency: { defaultCurrency: CurrencyCode }
  dateFormatPreference: { dateFormatPreference: DateFormatKey | null }
  externalDomains: string[]
  fallbackAssignee: AssigneeEntity[]
  hasSsoEnabled: boolean
  hasDirectorySyncEnabled: boolean
  userSyncConfig: UserSyncConfig
}

export const DEFAULT_CURRENCY: CurrencyCode = 'USD'

export const defaultSettings: OrganisationSettings = {
  budgetApprovalThresholdColumnsVisibility: {
    inBudget: false,
    departments: false,
  },
  defaultCurrency: { defaultCurrency: DEFAULT_CURRENCY },
  dateFormatPreference: { dateFormatPreference: null },
  fallbackAssignee: [],
  externalDomains: [],
  hasSsoEnabled: false,
  hasDirectorySyncEnabled: false,
  userSyncConfig: defaultUserSyncConfig,
} as const
